<style scoped>
.cartao-virtual-print {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.cartao-virtual-print-header {
  display: flex;
  flex-flow: row;
  justify-content: right;
  width: 100%;
}

.cartao-virtual-print-content {
  margin-bottom: 27px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.cartao {
  height: 5cm;
  width: 8.5cm;
  background-size: contain;
  border-radius: 15px;
  position: absolute;;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.cartao-container {
  height: 5cm;
  width: 8.5cm;
  border-radius: 15px;
  position: relative;
  border: 1px solid #555;
}

@media print {
  * {
    -webkit-print-color-adjust: exact;
  }

  .cartao-virtual-print-header {
    display: none;
  }
}
</style>
<template>
  <div
    class="cartao-virtual-print"
  >
    <div class="cartao-virtual-print-header">
      <el-button
        class="button-voltar"
        type="text"
        @click="close"
      >
        <i class="el-icon-back"/> Voltar
      </el-button>
      <el-button
        class="button-voltar"
        type="text"
        @click="imprimir"
      >
        Imprimir
      </el-button>
    </div>
    <div
      v-if="cartao"
      class="cartao-virtual-print-content"
    >
      <img
        style="height: 13cm; margin-right: -8px;"
        src="@/assets/img/recorte-esquerda@2x.png"
      >
      <div style="display:flex; flex-flow: column nowrap;">
        <div
          v-if="cartao.frente"
          class="cartao-container"
        >
          <el-image
            :src="cartao.frente.background"
            class="cartao"
            style="z-index: 1"
          />
          <el-image
            :src="cartao.frente.data"
            class="cartao"
            style="z-index: 2"
          />
        </div>
        <div
          v-if="cartao.verso"
          class="cartao-container"
        >
          <el-image
            :src="cartao.verso.background"
            class="cartao"
            style="z-index: 1"
          />
          <el-image
            :src="cartao.verso.data"
            class="cartao"
            style="z-index: 2"
          />
        </div>
      </div>
      <img
        style="height: 13cm;"
        src="@/assets/img/recorte-direita@2x.png"
      >
    </div>
    <div
      style="max-width: 320px"
    >
      <div style="font: normal normal 600 24px/29px Open Sans; font-weight: 600; letter-spacing: 0; color: #333333; margin-bottom: 15px;">
        Carências
      </div>
      <table
        v-if="carencias.length > 0"
        style="font: normal normal 600 14px/19px Open Sans; letter-spacing: 0; color: #555555; width: 100%;"
      >
        <tr
          v-for="(carencia, i) in carencias"
          :key="i"
          style="border-bottom: 1px solid #DDDDDD; height: 43px;"
        >
          <td style="border-bottom: 1px solid #DDDDDD; ">{{ carencia.tipoServico }}</td>
          <td style="border-bottom: 1px solid #DDDDDD; ">{{ parseDate(carencia.carencia) }}</td>
        </tr>
      </table>
      <div v-else>
        Nenhuma carência.
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'CartaoVirtualImpressao',
  props: {
    carencias: {
      type: Array,
      default: () => []
    },
    cartao: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.myOpen = this.value
  },
  methods: {
    close () {
      this.$emit('close', false)
    },
    parseDate (value) {
      const rgxData = /^\d{4}-\d{2}-\d{2}$/
      if (rgxData.test(value)) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }

      return value
    },
    imprimir () {
      window.print()
    }
  }
}
</script>
